import { observer } from "mobx-react-lite";
import { useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as UploadLogoSvg } from "../../../../../assets/UploadLogo.svg";
import { ReactComponent as BackArrowSvg } from "../../../../../assets/backarrow.svg";
import { ReactComponent as DeleteBasketSvg } from "../../../../../assets/deleteBasket.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import { vendorSchema } from "../../../../../app/validation/validationSchema";
import { SelectTemp } from "../../../../../app/common/form/Custom";
import {
  ReturnLocation,
  ReturnLocationForm,
} from "../../../../../app/models/shipping";
import { selectStateOptions } from "../../../../../app/common/options/categoryOptions";
import { useStore } from "../../../../../app/stores/store";
import Loading from "../../../../../app/layout/Loading";
import { ReactComponent as ThumbsUpSvg } from "../../../../../assets/navbericon/thumbsup.svg";
import Modal from "../../../../../app/common/modals/Custom";
import responseCodes from "../../../../../app/common/hooks/helpers";
import { toast } from "react-toastify";

const NewReturnLocation = () => {
  const navigate = useNavigate();
  const { shippingStore } = useStore();
  const { loadingInitial, addReturnLocations } = shippingStore;
  const [modal, setModal] = useState("");
  const [inputField, setInputField] = useState(new ReturnLocationForm());

  const handleAddReturnLocation = (values: any, setValues: any) => {
    const newReturnLocation = new ReturnLocation();
    let returnLocations = [...values.returnLocations, newReturnLocation];
    setValues({ ...values, returnLocations: returnLocations });
  };

  const handleRemoveReturnLocation = (
    values: any,
    setValues: any,
    index: number
  ) => {
    var returnLocations = [...values.returnLocations];
    returnLocations.splice(index, 1);
    setValues({ ...values, returnLocations: returnLocations });
  };

  const saveForm = async (values: any) => {
    // console.log(values);
    await addReturnLocations([...values.returnLocations]).then((res) => {
      if (res?.responseCode === responseCodes.response_00) {
        toast.info(res.responseMessage);
        setModal("success");
      }
    });
  };

  // useEffect(() => {
  //   handleAddReturnLocation();
  // }, []);
  return (
    <div className={styles.locationWrapper}>
      {loadingInitial === "loading" && <Loading />}
      {modal === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>
                Return Location{inputField.returnLocations.length > 1 && "s"}{" "}
                Added Successfully
              </p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate(-1)}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}{" "}
      <div className={styles.header}>
        <div className={styles.back}>
          <BackArrowSvg onClick={() => navigate(-1)} />
          <span>Go back</span>
        </div>
      </div>
      <div className={styles.headerTitle}>Preferred Return Location</div>
      {/* <div className={styles.shippingAddressWrapper}> */}
      <Formik
        initialValues={inputField}
        // enableReinitialize
        onSubmit={saveForm}
        validationSchema={vendorSchema.locationInfo}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          setValues,
          isValid,
          isSubmitting,
          touched,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FieldArray
                name="returnLocations"
                render={(arrayHelpers) => {
                  const returnLocations = values.returnLocations;
                  return (
                    <div className={styles.shippingAddressWrapper}>
                      {returnLocations.map((location, index) => {
                        return (
                          <div className={styles.shippingAddress} key={index}>
                            <div className={styles.shippingAddressInfo}>
                              <div className={styles.name}>Address</div>
                              <div className={styles.contact}>
                                <div className={styles.mail}>
                                  <div className={styles.lone}>
                                    <Field
                                      placeholder="Enter address here ..."
                                      name={`returnLocations.${index}.address`}
                                      style={{ height: 48 }}
                                      onChange={(e: any) => {
                                        setFieldValue(
                                          `returnLocations.${index}.address`,
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`returnLocations.${index}.address`}
                                      render={(error) => (
                                        <Label
                                          basic
                                          color="red"
                                          content={error}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={styles.shippingAddressInfo}>
                              <div className={styles.name}>City</div>
                              <div className={styles.contact}>
                                <div className={styles.mail}>
                                  <div className={styles.lone}>
                                    <Field
                                      placeholder="Enter city here ..."
                                      name={`returnLocations.${index}.city`}
                                      style={{ height: 48 }}
                                      onChange={(e: any) => {
                                        setFieldValue(
                                          `returnLocations.${index}.city`,
                                          e.target.value
                                        );
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`returnLocations.${index}.city`}
                                      render={(error) => (
                                        <Label
                                          basic
                                          color="red"
                                          content={error}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={styles.shippingAddressInfo}>
                              <div className={styles.name}>State</div>
                              <div className={styles.contact}>
                                <div className={styles.mail}>
                                  <div className={styles.lone}>
                                    <SelectTemp
                                      inputType="text"
                                      labelStyle={{ margin: 0 }}
                                      placeholder={"Select State"}
                                      options={selectStateOptions
                                        .sort(function (x, y) {
                                          let a = x.value.toUpperCase(),
                                            b = y.value.toUpperCase();
                                          return a === b ? 0 : a > b ? 1 : -1;
                                        })
                                        .map((state, valueIndex) => ({
                                          key: valueIndex,
                                          label: state.value,
                                          value: state.value,
                                        }))}
                                      onValueChange={(e: any) => {
                                        setFieldValue(
                                          `returnLocations.${index}.state`,
                                          e.value
                                        );
                                      }}
                                      value={{
                                        label: returnLocations[index].state,
                                      }}
                                      name={`returnLocations.${index}.state`}
                                    />
                                    <ErrorMessage
                                      name={`returnLocations.${index}.state`}
                                      render={(error) => (
                                        <Label
                                          basic
                                          color="red"
                                          content={error}
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {index !== 0 && (
                              <div className={`${styles.delete}`}>
                                <div className={styles.deleteAlt}></div>
                                <DeleteBasketSvg
                                  onClick={() =>
                                    handleRemoveReturnLocation(
                                      values,
                                      setValues,
                                      index
                                    )
                                  }
                                />
                              </div>
                            )}
                            {index === 0 && returnLocations.length !== 1 && (
                              <div className={styles.respace}></div>
                            )}
                          </div>
                        );
                      })}
                      {returnLocations.length < 5 && (
                        <div className={styles.uploadBoxWrapper}>
                          <div
                            className={styles.uploadBox}
                            onClick={() =>
                              handleAddReturnLocation(values, setValues)
                            }
                          >
                            <div className={styles.uploadBoxInner}>
                              <div className={styles.svgBox}>
                                <UploadLogoSvg />
                              </div>
                              <div className={styles.newUploadText}>
                                Add another Location
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }}
              />
              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  <Button
                    positive
                    className={styles.bulkProduct}
                    type="submit"
                    disabled={!isValid}
                  >
                    <div className={styles.positive}>
                      <span>Save</span>
                    </div>
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      {/* </div> */}
    </div>
  );
};

export default observer(NewReturnLocation);
